import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { DialogConfig } from '../../dialog/dialog-config';
import { DialogRef } from '../../dialog/dialog-ref';

@Component({
    selector: 'app-download-popup',
    templateUrl: './download-popup.component.html',
    standalone: false
})
export class DownloadPopupComponent implements OnInit {
  public archiveConfig:any = {};
  public downloadOnly:any = [];
  public numberDay:string = "All";
  constructor( public dialog: DialogRef,public dialogConfig: DialogConfig,public roleService:RolePermissionService,public appService:AppService) { }

  ngOnInit(){
    this.archiveConfig = this.dialogConfig.popupConfig;
    if(this.archiveConfig != undefined && this.archiveConfig.list != undefined){
      this.downloadOnly = this.archiveConfig.list.filter((c)=>{return c.download_only == true});
      if(this.archiveConfig.list.length>0 && this.archiveConfig.list[0]['change_label'] != undefined && this.archiveConfig.list[0]['change_label'] && this.archiveConfig.list[0]['minDateNumber'] != undefined){
        this.numberDay = this.appService.getArchiveConfigs()[this.archiveConfig.list[0]['minDateNumber']]+" Days";
      }
    }
   
  }
  downloadBtn(type,$event,obj?){
    if($event != undefined && $event.ctrlKey != undefined && $event.ctrlKey){
      var dta: any = {};
      dta={type:type,chunk_download:true};
      if(obj != undefined && obj.downloadType!=undefined && obj.downloadType == 'xlDownload'){
      dta['isCurrentXls'] = true;
      }
      var chunkSize = localStorage.getItem("chunk_size");
      if(chunkSize != undefined && chunkSize){
        dta['chunk_size'] = chunkSize;
      }
      
      console.log("Chunk Download Activated");
      this.dialog.close(dta);
    }else{
      if(obj != undefined && obj.downloadType!=undefined && obj.downloadType == 'xlDownload'){
      this.dialog.close({
        type:type,
        isCurrentXls:true
      });
      }else{
      this.dialog.close(type);
      }
    }
    
    // this.smartModalService.sendResult(type);
  }
  setArchivePolicy(archiveConfig) {
    this.dialog.close({ 'archiveConfig': archiveConfig });
  }
}
